import EmailTemplate, { EMAIL_TEMPLATE_KEYS } from '../types/EmailTemplate';

 
export const DEFAULT_TEMPLATES: Record<string, EmailTemplate> = {
  [EMAIL_TEMPLATE_KEYS.WELCOME]: {
    itemId: EMAIL_TEMPLATE_KEYS.WELCOME,
    key: EMAIL_TEMPLATE_KEYS.WELCOME,
    name: 'Welcome Email',
    subjectTemplate: 'Welcome to ${orgName} on Gratigolf!',
    htmlTemplate: `<!DOCTYPE html>
<html>
<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <style>
    body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; line-height: 1.6; color: #333; }
    .container { max-width: 600px; margin: 0 auto; padding: 20px; }
    .header { background-color: #4CAF50; padding: 20px; text-align: center; color: white; border-radius: 5px 5px 0 0; }
    .content { background-color: #f9f9f9; padding: 20px; border-left: 1px solid #ddd; border-right: 1px solid #ddd; }
    .footer { background-color: #f1f1f1; padding: 15px; text-align: center; font-size: 12px; color: #777; border-radius: 0 0 5px 5px; border: 1px solid #ddd; }
    .button { display: inline-block; background-color: #4CAF50; color: white; padding: 12px 24px; text-decoration: none; border-radius: 4px; font-weight: bold; margin: 15px 0; }
    .logo { margin-bottom: 15px; }
    ul { margin: 10px 0; padding-left: 20px; }
    li { margin: 5px 0; }
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h1>\${heading}</h1>
    </div>
    <div class="content">
      <p>Hello \${name},</p>
      \${orgListHtml}
      <p>To complete your registration and begin to participate in the league, please create your account by clicking the button below:</p>
      <div style="text-align: center;">
        <a href="\${url}" class="button">Create Your Account</a>
      </div>
      <p>If the button doesn't work, you can copy and paste this link into your browser:</p>
      <p style="word-break: break-all; font-size: 12px; color: #666;">\${url}</p>
      <p>We're excited to have you join us!</p>
    </div>
    <div class="footer">
      <p>&copy; \${year} Gratisports, Inc. All rights reserved.</p>
      <p>If you didn't request this email, please ignore it.</p>
    </div>
  </div>
</body>
</html>`,
    textTemplate: `Hello \${name},

\${orgListText}To complete your registration and start enjoying all the benefits of membership, please create your account by visiting:
\${url}

We're excited to have you join us!

© \${year} Gratisports, Inc. All rights reserved.`,
    variables: ['name', 'heading', 'orgListHtml', 'orgListText', 'url', 'year'],
  },

  [EMAIL_TEMPLATE_KEYS.WELCOME_PRO]: {
    itemId: EMAIL_TEMPLATE_KEYS.WELCOME_PRO,
    key: EMAIL_TEMPLATE_KEYS.WELCOME_PRO,
    name: 'Welcome Pro Email',
    subjectTemplate: 'Welcome to ${orgName} on Gratigolf!',
    htmlTemplate: `<!DOCTYPE html>
<html>
<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <style>
    body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; line-height: 1.6; color: #333; }
    .container { max-width: 600px; margin: 0 auto; padding: 20px; }
    .header { background-color: #4CAF50; padding: 20px; text-align: center; color: white; border-radius: 5px 5px 0 0; }
    .content { background-color: #f9f9f9; padding: 20px; border-left: 1px solid #ddd; border-right: 1px solid #ddd; }
    .footer { background-color: #f1f1f1; padding: 15px; text-align: center; font-size: 12px; color: #777; border-radius: 0 0 5px 5px; border: 1px solid #ddd; }
    .button { display: inline-block; background-color: #4CAF50; color: white; padding: 12px 24px; text-decoration: none; border-radius: 4px; font-weight: bold; margin: 15px 0; }
    .logo { margin-bottom: 15px; }
    ul { margin: 10px 0; padding-left: 20px; }
    li { margin: 5px 0; }
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h1>\${heading}</h1>
    </div>
    <div class="content">
      <p>Hello \${name},</p>
      \${orgListHtml}
      <p>To complete your registration and begin to work with the league, please create your account by clicking the button below:</p>
      <div style="text-align: center;">
        <a href="\${url}" class="button">Create Your Account</a>
      </div>
      <p>If the button doesn't work, you can copy and paste this link into your browser:</p>
      <p style="word-break: break-all; font-size: 12px; color: #666;">\${url}</p>
      <p>We're excited to have you join us!</p>
    </div>
    <div class="footer">
      <p>&copy; \${year} Gratisports, Inc. All rights reserved.</p>
      <p>If you didn't request this email, please ignore it.</p>
    </div>
  </div>
</body>
</html>`,
    textTemplate: `Hello \${name},

\${orgListText}To complete your registration and start enjoying all the benefits of membership, please create your account by visiting:
\${url}

We're excited to have you join us!

© \${year} Gratisports, Inc. All rights reserved.`,
    variables: ['name', 'heading', 'orgListHtml', 'orgListText', 'url', 'year'],
  },

  [EMAIL_TEMPLATE_KEYS.TEAM_MEMBER_REQUEST]: {
    itemId: EMAIL_TEMPLATE_KEYS.TEAM_MEMBER_REQUEST,
    key: EMAIL_TEMPLATE_KEYS.TEAM_MEMBER_REQUEST,
    name: 'Team Member Request Notification',
    subjectTemplate: "Review ${teamName}'s new member request",
    htmlTemplate: `<!DOCTYPE html>
<html>
<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <style>
    body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; line-height: 1.6; color: #333; }
    .container { max-width: 600px; margin: 0 auto; padding: 20px; }
    .header { background-color: #1976d2; padding: 20px; text-align: center; color: white; border-radius: 5px 5px 0 0; }
    .content { background-color: #f9f9f9; padding: 20px; border-left: 1px solid #ddd; border-right: 1px solid #ddd; }
    .footer { background-color: #f1f1f1; padding: 15px; text-align: center; font-size: 12px; color: #777; border-radius: 0 0 5px 5px; border: 1px solid #ddd; }
    .details { background-color: #fff; padding: 15px; border: 1px solid #e0e0e0; border-radius: 4px; margin: 15px 0; }
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h2>New Member Request</h2>
    </div>
    <div class="content">
      <p><strong>\${requesterName}</strong> has requested adding a member to their team:</p>
      <div class="details">
        <p><strong>Who:</strong> \${memberName}</p>
        <p><strong>Email:</strong> \${memberEmail}</p>
        \${handicapIdHtml}
      </div>
      <p>Since this person is not a member of the <strong>\${orgName}</strong> org, you will need to approve this request for \${memberName} to receive an invitation.</p>
      <p>Please go to the <a href="\${orgUrl}">\${orgName} Invites tab</a> to review.</p>
      <p>Thank you.</p>
    </div>
    <div class="footer">
      <p>&copy; \${year} Gratisports, Inc. All rights reserved.</p>
    </div>
  </div>
</body>
</html>`,
    textTemplate: `\${requesterName} has requested adding a member to their team:

Who: \${memberName}
Email: \${memberEmail}
\${handicapIdText}
Since this person is not a member of the \${orgName} org, you will need to approve this request for \${memberName} to receive an invitation.

Please go to the \${orgName} Invites tab to review: \${orgUrl}

Thank you.`,
    variables: ['requesterName', 'memberName', 'memberEmail', 'handicapIdHtml', 'handicapIdText', 'orgName', 'orgUrl', 'teamName', 'year'],
  },

  [EMAIL_TEMPLATE_KEYS.LEAGUE_MEMBER_REQUEST]: {
    itemId: EMAIL_TEMPLATE_KEYS.LEAGUE_MEMBER_REQUEST,
    key: EMAIL_TEMPLATE_KEYS.LEAGUE_MEMBER_REQUEST,
    name: 'League Member Request Notification',
    subjectTemplate: "Review ${leagueName}'s new member request",
    htmlTemplate: `<!DOCTYPE html>
<html>
<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <style>
    body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; line-height: 1.6; color: #333; }
    .container { max-width: 600px; margin: 0 auto; padding: 20px; }
    .header { background-color: #1976d2; padding: 20px; text-align: center; color: white; border-radius: 5px 5px 0 0; }
    .content { background-color: #f9f9f9; padding: 20px; border-left: 1px solid #ddd; border-right: 1px solid #ddd; }
    .footer { background-color: #f1f1f1; padding: 15px; text-align: center; font-size: 12px; color: #777; border-radius: 0 0 5px 5px; border: 1px solid #ddd; }
    .details { background-color: #fff; padding: 15px; border: 1px solid #e0e0e0; border-radius: 4px; margin: 15px 0; }
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h2>New League Member Request</h2>
    </div>
    <div class="content">
      <p><strong>\${requesterName}</strong> has requested adding a member to <strong>\${leagueName}</strong>:</p>
      <div class="details">
        <p><strong>Who:</strong> \${memberName}</p>
        <p><strong>Email:</strong> \${memberEmail}</p>
        \${handicapIdHtml}
      </div>
      <p>Since this person is not a member of the <strong>\${orgName}</strong> org, you will need to approve this request for \${memberName} to receive an invitation.</p>
      <p>Please go to the <a href="\${orgUrl}">\${orgName} Invites tab</a> to review.</p>
      <p>Thank you.</p>
    </div>
    <div class="footer">
      <p>&copy; \${year} Gratisports, Inc. All rights reserved.</p>
    </div>
  </div>
</body>
</html>`,
    textTemplate: `\${requesterName} has requested adding a member to \${leagueName}:

Who: \${memberName}
Email: \${memberEmail}
\${handicapIdText}
Since this person is not a member of the \${orgName} org, you will need to approve this request for \${memberName} to receive an invitation.

Please go to the \${orgName} Invites tab to review: \${orgUrl}

Thank you.`,
    variables: ['requesterName', 'leagueName', 'memberName', 'memberEmail', 'handicapIdHtml', 'handicapIdText', 'orgName', 'orgUrl', 'year'],
  },

  [EMAIL_TEMPLATE_KEYS.REINSTATED]: {
    itemId: EMAIL_TEMPLATE_KEYS.REINSTATED,
    key: EMAIL_TEMPLATE_KEYS.REINSTATED,
    name: 'Reinstated Member Email',
    subjectTemplate: 'Welcome back to ${orgName}',
    htmlTemplate: `<!DOCTYPE html>
<html>
<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <style>
    body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; line-height: 1.6; color: #333; }
    .container { max-width: 600px; margin: 0 auto; padding: 20px; }
    .header { background-color: #4CAF50; padding: 20px; text-align: center; color: white; border-radius: 5px 5px 0 0; }
    .content { background-color: #f9f9f9; padding: 20px; border-left: 1px solid #ddd; border-right: 1px solid #ddd; }
    .footer { background-color: #f1f1f1; padding: 15px; text-align: center; font-size: 12px; color: #777; border-radius: 0 0 5px 5px; border: 1px solid #ddd; }
    .button { display: inline-block; background-color: #4CAF50; color: white; padding: 12px 24px; text-decoration: none; border-radius: 4px; font-weight: bold; margin: 15px 0; }
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h1>Welcome Back!</h1>
    </div>
    <div class="content">
      <p>Hello \${name},</p>
      <p>You are now a member of <strong>\${orgName}</strong>!</p>
      <p>The next step is to log in to your account:</p>
      <div style="text-align: center;">
        <a href="\${url}" class="button">Log In</a>
      </div>
      <p>If the button doesn't work, you can copy and paste this link into your browser:</p>
      <p style="word-break: break-all; font-size: 12px; color: #666;">\${url}</p>
      <p>We're glad to have you back!</p>
    </div>
    <div class="footer">
      <p>&copy; \${year} Gratisports, Inc. All rights reserved.</p>
    </div>
  </div>
</body>
</html>`,
    textTemplate: `Hello \${name},

You are now a member of \${orgName}!

The next step is to log in to your account:
\${url}

We're glad to have you back!

© \${year} Gratisports, Inc. All rights reserved.`,
    variables: ['name', 'orgName', 'url', 'year'],
  },
  [EMAIL_TEMPLATE_KEYS.USGA_ACCESS_EXPLAINER]: {
    itemId: EMAIL_TEMPLATE_KEYS.USGA_ACCESS_EXPLAINER,
    key: EMAIL_TEMPLATE_KEYS.USGA_ACCESS_EXPLAINER,
    name: 'USGA Score Posting — Approval Explainer',
    subjectTemplate: '${eventName}: approve Gratigolf to post your score to the USGA',
    htmlTemplate: `<!DOCTYPE html>
<html>
<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <style>
    body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; line-height: 1.6; color: #333; }
    .container { max-width: 600px; margin: 0 auto; padding: 20px; }
    .header { background-color: #4CAF50; padding: 20px; text-align: center; color: white; border-radius: 5px 5px 0 0; }
    .content { background-color: #f9f9f9; padding: 20px; border-left: 1px solid #ddd; border-right: 1px solid #ddd; }
    .footer { background-color: #f1f1f1; padding: 15px; text-align: center; font-size: 12px; color: #777; border-radius: 0 0 5px 5px; border: 1px solid #ddd; }
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h2>Posting your score to the USGA</h2>
    </div>
    <div class="content">
      <p>Hello \${name},</p>
      <p><strong>\${eventName}</strong> (\${orgName}) posts scores to the USGA on behalf of the players. Gratigolf only does this with your permission.</p>
      <p>You will receive an email from the USGA, sent to the email address you gave the USGA, asking you to approve Gratigolf accessing your golf scoring record in order to post scores.</p>
      <p>In that email, tap <strong>"Scoring Record Request"</strong>, then <strong>"Acknowledge"</strong>.</p>
      <p>If you choose not to give access, you are responsible for posting your own score.</p>
      <p>You can read how Gratigolf uses your information in our <a href="\${privacyUrl}">privacy policy</a>.</p>
    </div>
    <div class="footer">
      <p>&copy; \${year} Gratisports, Inc. All rights reserved.</p>
    </div>
  </div>
</body>
</html>`,
    textTemplate: `Hello \${name},

\${eventName} (\${orgName}) posts scores to the USGA on behalf of the players. Gratigolf only does this with your permission.

You will receive an email from the USGA, sent to the email address you gave the USGA, asking you to approve Gratigolf accessing your golf scoring record in order to post scores.

In that email, tap "Scoring Record Request", then "Acknowledge".

If you choose not to give access, you are responsible for posting your own score.

How Gratigolf uses your information: \${privacyUrl}

© \${year} Gratisports, Inc. All rights reserved.`,
    variables: ['name', 'eventName', 'orgName', 'privacyUrl', 'year'],
  },
};
